import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IUserState, userFeatureKey } from './state';

export const userStateSelector = createFeatureSelector<IUserState>(userFeatureKey);
export const userBettingSettingsSelector = createSelector(userStateSelector, (st) => st.bettingSettings);
